import { ScreenTemplate } from '@components-fabric/types';
import { findFirstValueDefinedFromArray, selectNonEmptyEntries } from '@dirootie-toolbox/objects';
import { getTitle } from './get-title';
import { isNotEmpty, isNotUndefined } from 'ramda-adjunct';

export const getPageProps = (obj: ScreenTemplate) => {
  const entries = selectNonEmptyEntries(
  [
    "breadcrumbs",
    "breadcrumb",
    "route.breadcrumbs",
    "route.breadcrumb",
    "section.breadcrumbs",
    "section.breadcrumb",
  ],obj);
  const title = getTitle(obj);
  const pageProps = {
    breadcrumbs:  true,
    breadcrumb: undefined,
    title
  }
  const breadcrumbs = findFirstValueDefinedFromArray("breadcrumbs",entries);
  if (isNotUndefined(breadcrumbs) && isNotEmpty(breadcrumbs)) {
    pageProps.breadcrumbs = breadcrumbs;
  }
  if(breadcrumbs === true){
    const breadcrumb = findFirstValueDefinedFromArray("breadcrumb",entries) ?? title ?? "NOT_SET";
    pageProps.breadcrumb = breadcrumb;
  }
  return pageProps;
}
